import { render, staticRenderFns } from "./xc-permission-desc.vue?vue&type=template&id=616e984e&scoped=true"
import script from "./xc-permission-desc.vue?vue&type=script&lang=js"
export * from "./xc-permission-desc.vue?vue&type=script&lang=js"
import style0 from "./xc-permission-desc.vue?vue&type=style&index=0&id=616e984e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616e984e",
  null
  
)

export default component.exports